angular.module("vgresiduos").controller("PlanEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/planos/${$stateParams.id}`);
		};
	}
]);
